<template>
	<el-drawer size="645px" title="人员管理" :visible.sync="drawer" :modal-append-to-body="false" :wrapperClosable="false" class="customer-drawer-common">
		<el-transfer 
			v-model="value" 
			:data="lists" 
			:titles="['可选人员','技能组内']"
			filterable
			:filter-method="filterMethod"
			filter-placeholder="请输入用户名"
			@change="handleChangeTransfer"
			:props="{
				key: 'account',
				label: 'nickname'
			}" 
			v-loading="loading">
		</el-transfer>
		<!-- <div class="footer">
			<el-button @click="drawer = false"  size="mini">取 消</el-button>
			<el-button type="primary" size="mini" @click="onSave" :loading="loadingBtn">{{ loadingBtn ? '提交中 ...' : '确 定' }}
			</el-button>
		</div> -->
	</el-drawer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	computed: {
		...mapGetters([
			'userInfo',  
		])
	},
	data() {
		return {
			drawer: false,
			value:[],
			lists:[],
			loadingBtn:false,
			skillGroup:'',
			brand:'',
			loading:false
		}
	},
	methods: {
		handleChangeTransfer(arr, direction, data) {
			if(direction === 'left') {
				this.$api.apiAddLarkswitchManageQueueAgentDelete({
					projectCode:this.userInfo.brandIdentify,
					account:data.length > 0 ? data.join(',') : '',
					queueName:this.skillGroup
				}).then(res => {
					if(res.errcode == 0) {
						this.$notify.success('操作成功');
					}
				});
			} else {
				this.$api.apiAddLarkswitchManageQueueAgentList({
					projectCode:this.userInfo.brandIdentify,
					account:data.length > 0 ? data.join(',') : '',
					queueName:this.skillGroup
				}).then(res => {
					if(res.errcode == 0) {
						this.$notify.success('操作成功');
					}
				});
			}
		},
		filterMethod(query, item) {
			return item.nickname.indexOf(query) > -1;
		},
		async getAllUser(){
			await this.$api.apiPostUserAgentCodeList().then(res => {
				console.log(res.data)
				this.loading = false;
				this.lists = res.data;
			})
		},
		async getUser(){
			await this.$api.apiPostLarkswitchManageQueueAgentList({queueName:this.skillGroup}).then(res => {
				if(res.errcode != 0) return;
				this.value = [];
				for(let item of res.data){
					if(item?.account) {
						this.value.push(item.account)
					}
				}
				console.log(this.value)
				this.loading = false;
			})
		},
		onSave(){
			this.$api.apiAddLarkswitchManageQueueAgentList({
				agentName: this.value.length > 0 ? this.value.join(',') : '',
				queueName:this.skillGroup
			}).then(res => {
				if(res.errcode == 0) {
					this.$notify.success('操作成功');
					this.drawer = false;
				}
			})
		},
		async onOpen(row){
			this.drawer = true;
			this.loading = true;
			this.skillGroup = row.queueName;
			this.brand = row.projectCode;
			await this.getAllUser();
			await this.getUser()
		}
	}
}
</script>

<style>
</style>
